import React from 'react';

export const SubTitle = ({ children }: SubTitleProps): React.JSX.Element => {
    return <p className="text-xl">{children}</p>;
};

interface SubTitleProps {
    children: string;
}

export default SubTitle;
